/* External */
import { useCallback } from 'react';

/* Utils */
import { useStore } from './LoadingProvider';
import { HIDE_LOADING, SHOW_LOADING } from './loadingActions';

export const useLoading = () => {
  const [state, dispatch] = useStore();
  return {
    isLoading: state,
    showLoading: useCallback(() => dispatch({ type: SHOW_LOADING }), [dispatch]),
    hideLoading: useCallback(() => dispatch({ type: HIDE_LOADING }), [dispatch]),
  };
};

export { default } from './LoadingProvider';
